import { Col, Popover, Progress, Row } from 'antd';
import { Rule } from 'antd/lib/form';
import React, { ReactElement, useEffect, useState } from 'react';
import { getISTDateWithTimeSeconds } from '../../../utils/dateTimeUtils';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import {
  EXTENDED_STATUS, getFileSizeLimitMessage, HIS_UPLOAD_STATUS, MB2Bytes,
  NEW_UPLOAD_STATUS, progress, UPLOAD_STATUS,
} from '../../constants/crmConstants';
import { ReactComponent as FileIcon } from '../../../assets/images/svg/HIS_File_Icon.svg';
import { ReactComponent as ViewIcon } from '../../../assets/images/svg/HIS_View_Document.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/images/svg/HIS_Download_Document.svg';
import { ReactComponent as File_Size } from '../../../assets/images/svg/File_Size_Info.svg';
import { hisFileDownload } from '../../../store/actions/fileAction';
import { useDispatch, useSelector } from 'react-redux';
import { centeredNotification } from '../../../utils/utility';
import './fileUpload.less';
import FormCheckBox from '../crmFormElement/FormCheckBox/FormCheckBox';
import { RootState } from '../../../store';
import {
  hisPrintClaimPDF, setClassificationArray, setHisCheckedFiles,
  setHisSelectedFiles, setUpdatedLetters, setUploadedFiles, submitFile,
} from '../../../store/actions/newAdmissionAction';
import { HospitalState } from '../../../store/models/hospitalModel';
import { getCurrentDateTime, invalidFileTypeErrorMessage } from '../../../modules/crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import moment from 'moment';
import { getFileType, getMimeTypeFromExtension } from '../../../utils/fileUploadUtils';
import { isEmpty } from 'lodash';
import ApplicationDetail from '../../services/applicationDetail.service';

const HisUploadListItem = ({ file, indexRow, onRemove, fileListLength, selectionAllowed = false,
  onSelectToggle, newUploads, showProgress, isDocumentTypeRequired = true, downloadAll,
  form, buddhimedCallBack, setpdfPreview, setTestPdf, handleValueChange, maxFileSize, updateErrorMessage,
  numberOfFilesLimit, isCancel, letter, setLetters, setFullLetterList, fullLetterList, nextStatus,
  setVisibleLetters }: any): ReactElement => {
  const dispatch = useDispatch();
  const rules: Rule[] = [];
  const [progress33, progress66, progress100] = progress;
  const { selectedHISFiles, uploadedFiles, checkedHISFiles, classificationArray } =
    useSelector((state: RootState): any => state.newAdmission);
  rules.push({ required: true });
  interface FileType {
    uid: string;
    size?: number;
    [key: string]: any;
  }
  const { fileName, fileUploadedatHIS, status, extendedStatus, fileType = [] } = file;
  const { selectedPatientDetail, hospitalSearchPatientDetails }: any = useSelector((state: RootState): HospitalState => state.hospital);
  const { payerList: { payer } } = useSelector((state: RootState): any => state);
  const { allowedFileTypes } = payer || {};
  const fileTypeVal = fileName?.split('.').pop().toLowerCase();
  const [responses, setResponses] = useState([]);
  const [fileSize, setFileSize] = useState<number>(0);
  const [files, setFiles] = useState<FileType[]>([]);
  const [isMouseEntered, setIsMouseEntered] = useState(false);
  const hospitalSearchPatientDetail = hospitalSearchPatientDetails?.[0];
  const referenceId = selectedPatientDetail?.patientHISReferenceNumber ? selectedPatientDetail?.patientHISReferenceNumber :
    hospitalSearchPatientDetail?.patientHISReferenceNumber || '0';
  file.indexRow = indexRow;
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const visitInfo = !isEmpty(selectedPatientDetail)
    ? selectedPatientDetail
    : (!isEmpty(hospitalSearchPatientDetail))
      ? hospitalSearchPatientDetail
      : [];
  const { hisid, hisProviderID } =
    appdetails?._applicationDetail?.hospitalDetail?.providerConfigurableProperties;

  const maxFileLimit = maxFileSize * MB2Bytes;
  const visitDetails = visitInfo?.patientDetails;
  const ALLOWED_FILE_EXTENSIONS = ApplicationDetail.instance.getAllowedFileExtension();
  const parsedAllowedTypes = allowedFileTypes
    ? JSON.parse(allowedFileTypes)
    : ALLOWED_FILE_EXTENSIONS || {};
  const statusAllowedExtensions = parsedAllowedTypes?.[nextStatus];
  const invalidFileTypeErrorMsg = invalidFileTypeErrorMessage(statusAllowedExtensions);
  let customPercent = progress100;
  if (status === UPLOAD_STATUS.uploading) {
    customPercent = progress33;
  } else if (status === UPLOAD_STATUS.done) {
    customPercent = (extendedStatus === EXTENDED_STATUS.verified
      || extendedStatus === EXTENDED_STATUS.uploaded || (!extendedStatus && status === UPLOAD_STATUS.done)) ? progress100 : progress66;
  }

  const newFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === NEW_UPLOAD_STATUS);
  const hisFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === HIS_UPLOAD_STATUS);

  const bytesToMB = (sizeInBytes: any): any => {
    const sizeInMB = sizeInBytes / (1024 * 1024);
    const formattedSizeInMB = sizeInMB?.toFixed(3);
    const parsedSize = parseFloat(formattedSizeInMB);
    return !isNaN(parsedSize) ? `${formattedSizeInMB} MB` : '-';
  };

  const checkedFiles = [...checkedHISFiles];

  const responsesArray: string | any[] = [];
  const selectedFiles: string | any = {};

  const handleFileSubmission = (indexLine: any, response: any): any => {
    if (indexLine >= responsesArray.length) {
      responsesArray.length = indexLine + 1;
    }
    responsesArray[indexLine] = fileName;
    selectedFiles[indexLine] = fileName;
  };

  useEffect((): any => {
    if (uploadedFiles?.length) {
      // updateErrorMessage('');
      moveItemWithUidToFrontAndUpdateIndex();
    }
  }, []);

  useEffect((): any => {
    const timeoutId = setTimeout((): any => {
      const updatedFiles = files?.map((fileArr: any): any => {
        if (fileArr?.uid === file?.uid) {
          return { ...fileArr, size: fileSize };
        }
        return fileArr;
      });
      setFiles(updatedFiles);
    }, 900);
    return (): any => clearTimeout(timeoutId);
  }, [responses, fileSize, file]);

  const moveItemWithUidToFrontAndUpdateIndex = (letterArray?: any): any => {
    const selectedItems = fullLetterList?.filter((doc: any): any => doc?.checked);
    const unSelectedItems = fullLetterList?.filter((doc: any): any => !doc?.checked);

    // Set the reordered full list
    const newLetterList = [...selectedItems, ...unSelectedItems];
    setFullLetterList(newLetterList);
    dispatch(setUpdatedLetters(newLetterList));
    // Update visible letters to reflect the current pagination
    setVisibleLetters(newLetterList?.slice(0, letter?.length));
  };

  const processFile = (
    sourceFile: any,
    fileItem: any,
    response: any,
    tempUploadedFiles: any[],
    newClassifiedArray: any[],
    newData: any[],
  ): void => {
    const uploadedDetails = response?.['uploadedDetails']?.[0];
    if (uploadedDetails) {
      const fileGuid = uploadedDetails['fileGuid'];
      const filesName = uploadedDetails['fileName'];
      const fileSizeinBytes = uploadedDetails['fileSizeinBytes'];
      setResponses(response);
      handleFileSubmission(indexRow, response?.[0]);
      setFileSize(response?.['uploadedDetails']?.[0]?.fileSizeinBytes);

      // Update file and fileItem details
      fileItem.size = fileSizeinBytes;
      sourceFile.size = fileSizeinBytes;
      sourceFile.guid = fileGuid || file.guid || '';
      sourceFile.uid = fileGuid || file.uid || '';
      sourceFile.response = response || file.response || {};
      sourceFile.claimStatus = HIS_UPLOAD_STATUS;
      fileItem.claimStatus = HIS_UPLOAD_STATUS;
      fileItem.checked = tempUploadedFiles?.length < numberOfFilesLimit && fileItem?.size < maxFileLimit;
      sourceFile.checked = tempUploadedFiles?.length < numberOfFilesLimit && fileItem?.size < maxFileLimit;

      // Check if file is already uploaded
      const isFileAlreadyUploaded = [...uploadedFiles].some(
        (uploadedFile: any): any => uploadedFile?.uid === fileGuid,
      );
      // Add to tempUploadedFiles if not already uploaded
      if (!isFileAlreadyUploaded) {
        tempUploadedFiles?.push({
          ...sourceFile,
          claimStatus: HIS_UPLOAD_STATUS,
          status: 'done',
          extendedStatus: 'done',
          fileId: fileGuid,
          fileName: filesName,
          answer: 'yes',
          answerOn: getCurrentDateTime(),
          uid: fileGuid,
          lastModifiedDate: getCurrentDateTime(),
          response,
          name: filesName,
          size: fileSizeinBytes,
          uploadedOn: getISTDateWithTimeSeconds(new Date()),
        });
      }
      moveItemWithUidToFrontAndUpdateIndex(letter);

      if (tempUploadedFiles.length > numberOfFilesLimit) {
        updateErrorMessage(`Maximum file allowed is ${numberOfFilesLimit}`);
      } else if (fileItem?.size && fileItem?.size > maxFileLimit) {
        updateErrorMessage(`Maximum file limit is ${maxFileLimit / MB2Bytes}MB.`);
      } else if (!isFileAlreadyUploaded && response?.uploadedDetails?.length > 0) {
        uploadedFiles?.push({
          ...sourceFile,
          claimStatus: HIS_UPLOAD_STATUS,
          status: 'done',
          extendedStatus: 'done',
          fileId: fileGuid,
          fileName: filesName,
          answer: 'yes',
          answerOn: getCurrentDateTime(),
          uid: fileGuid,
          lastModifiedDate: getCurrentDateTime(),
          response,
          name: filesName,
          size: fileSizeinBytes,
          percent: 100,
          uploadedOn: getISTDateWithTimeSeconds(new Date()),
        });
        dispatch(setUploadedFiles(uploadedFiles));
      }

      // Update newData
      const tempNewData = [...newData];
      tempNewData?.push(fileItem);

      if (tempUploadedFiles.length <= numberOfFilesLimit) {
        if (response?.uploadedDetails?.length > 0) {
          newData?.push(fileItem);
          dispatch(setHisSelectedFiles(newData));
        }
      } else {
        updateErrorMessage(`Maximum file allowed is ${numberOfFilesLimit}`);
      }

      // Update classified array
      newClassifiedArray?.push({
        ...sourceFile,
        claimStatus: HIS_UPLOAD_STATUS,
        status: 'done',
        extendedStatus: 'done',
        fileId: fileGuid,
        fileName: filesName,
        answer: 'yes',
        answerOn: getCurrentDateTime(),
        uid: fileGuid,
        lastModifiedDate: getCurrentDateTime(),
        response,
        name: filesName,
        size: fileSizeinBytes,
        percent: 100,
        uploadedOn: getISTDateWithTimeSeconds(new Date()),
      });
      dispatch(setClassificationArray(newClassifiedArray));
    }
    fileItem.loading = false;
    file.loading = false;
  };

  const changeSelection = (event: any, fileItem: any, index: any): any => {
    const checked = event?.target?.checked;
    const newData = [...selectedHISFiles];
    const newUploadedFiles = [...uploadedFiles];
    const newClassifiedArray = [...classificationArray];
    // Filter uploaded files to retrieve files with specific statuses (NEW_UPLOAD_STATUS or HIS_UPLOAD_STATUS)
    // or files that are not marked as existing records
    const tempUploadedFiles = newUploadedFiles?.filter(
      (obj: any): any =>
        (obj?.status === NEW_UPLOAD_STATUS || obj?.status === HIS_UPLOAD_STATUS || !obj?.existingRecord),
    );

    dispatch(setHisCheckedFiles(checkedFiles));
    // Setting a flag to track if the current file is eligible for selection
    let isSelected = true;
    if (parsedAllowedTypes?.[nextStatus] && statusAllowedExtensions?.indexOf(fileTypeVal) < 0) {
      updateErrorMessage(invalidFileTypeErrorMsg);
      isSelected = false;
    }
    if (fileItem?.size && fileItem?.size > maxFileLimit) {
      isSelected = false;
      updateErrorMessage(`Maximum file limit is ${maxFileLimit / MB2Bytes}MB.`);
    }

    fileItem.loading = true;
    file.loading = true;
    if (isSelected && checked) {
      fileItem.isDeleted = false;
      fileItem.isRejected = false;
      fileItem.discrepancy = false;

      handleValueChange(newData);

      if (!(file?.uid || fileItem?.uid)) {
        // Call API if uid is not present
        const payload = {
          hisPatientSearchRefenceID: referenceId,
          fileName: fileItem?.fileName,
          index: indexRow,
          hisFileIdentifier: fileItem?.hisFileIdentifier,
          hisID: hisid,
          hisProviderID,
          ipNumber: visitDetails?.inpatientNumber,
          uhid: visitDetails?.registrationNumber,
          hisFileType: fileItem?.hisFileType,
          visitCode: visitDetails?.visitCode,
          visitType: visitDetails?.visitType,
          fileUploadedAtHIS: fileItem?.fileUploadedatHIS,
          ftpURL: fileItem?.ftpURL,
        };

        dispatch(
          submitFile(
            payload,
            (response: any): void => {
              onSuccess(response, fileItem, indexRow, fullLetterList);
              // On successful API response, process the file and update uploaded files
              processFile(
                file,
                fileItem,
                response,
                tempUploadedFiles,
                newClassifiedArray,
                newData,
              );
            },
            (error: any): void => {
              // Handle the error scenario
              onError(error, fileItem);
            },
          ),
        );
      } else {
        // If file already has a uid, simulate processing logic
        processFile(
          file,
          fileItem,
          file.response || {},
          tempUploadedFiles,
          newClassifiedArray,
          newData,
        );
      }
    } else {
      // Unchecking logic
      // Update file properties to mark it as unchecked and reset its order
      fileItem.checked = false;
      fileItem.orderFiles = false;

      /* Preserve form values before resetting,
      need to fix this approach for onRemove and onChangeSelection */
      const currFormValues = form.getFieldsValue();
      const {
        panNumber, fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge,
        inPatientNumber, isDischargeCase, settlementType, recieptNo, stayLength,
        patientPaidAmount, switchClick, courierAgencyName, dateOfDispatch, dateOfDelivery,
        podNo, handedOverTo, documentType, noOfFiles, documentSubmissionType, typeOfClaim,
        aadharNo, dispatchDate, consignmentNumber, courierName, branch, doctorName,
        doctorQualification,
      } = currFormValues || {};

      form?.resetFields();
      form.setFieldsValue({
        panNumber, fileUploadRemark, claimedAmount, dateOfAdmission, dateOfDischarge,
        inPatientNumber, isDischargeCase, settlementType, recieptNo, stayLength,
        patientPaidAmount, switchClick, courierAgencyName, dateOfDispatch, dateOfDelivery,
        podNo, handedOverTo, documentType, noOfFiles, documentSubmissionType, typeOfClaim,
        aadharNo, dispatchDate, consignmentNumber, courierName, branch, doctorName,
        doctorQualification,
      });
      // Find the index of the file in the selected HIS files array
      const objIndex = newData?.findIndex((obj: any): any => obj?.uid === fileItem?.uid);
      // Find the index of the file in the uploaded files array
      const hisFileUnselectedIndex = newUploadedFiles?.findIndex((obj: any): any => obj?.uid === fileItem?.uid);
      if (hisFileUnselectedIndex !== -1) {
        newUploadedFiles?.splice(hisFileUnselectedIndex, 1);
        dispatch(setUploadedFiles([...newUploadedFiles]));
      }
      fileItem.loading = false;
      file.loading = false;
      // Reorder items and update their indices
      moveItemWithUidToFrontAndUpdateIndex(letter);
      if (objIndex !== -1) {
        newData?.splice(objIndex, 1);
        dispatch(setHisSelectedFiles(newData));
        handleValueChange(newData);
      }
    }
  };
  // unselecting the HIS selected files when file limit is exceeding
  const currentFormValues = form?.getFieldsValue();
  if (newFileUploads?.length <= numberOfFilesLimit && hisFileUploads?.length) {
    const hisFileUIDs = new Set(hisFileUploads?.map((id: any): any => `checkbox_${id?.uid}`));
    Object?.keys(currentFormValues)?.forEach((key: string): any => {
      if (key?.startsWith('checkbox_')) {
        if (hisFileUIDs?.has(key)) {
          currentFormValues[key] = key || [];  // Ensure it's an array
        } else {
          currentFormValues[key] = undefined;  // Reset unchecked boxes
        }
      }
    });

    form.setFieldsValue(currentFormValues);
  } else {
    Object?.keys(currentFormValues)?.forEach((key: string): any => {
      if (key?.startsWith('checkbox_')) {
        currentFormValues[key] = undefined;
      }
    });
    form?.setFieldsValue(currentFormValues);
  }

  const onSuccess = (response: any, fileItem: any, indexRowValue: any, fullLetters: any): any => {
    const isAlreadyChecked = checkedFiles?.some((item: any): any => item?.uid === fileItem?.uid);
    if (!isAlreadyChecked) {
      checkedFiles?.push(fileItem);
    }
    const isPresent = checkedHISFiles?.some((item: any): any => {
      return item?.uid === fileItem?.uid;
    });
    fileItem.guid = response?.['uploadedDetails']?.[0]?.fileGuid;
    fileItem.size = response?.['uploadedDetails']?.[0]?.['fileSizeinBytes'];
    fileItem.index = indexRowValue;
    fileItem.fileName = response?.['uploadedDetails']?.[0]?.fileName;
    file.index = indexRowValue;
    file.guid = response?.['uploadedDetails']?.[0]?.fileGuid;
    file.uid = response?.['uploadedDetails']?.[0]?.fileGuid;
    file.size = response?.['uploadedDetails']?.[0]?.['fileSizeinBytes'];
    file.fileName = response?.['uploadedDetails']?.[0]?.fileName;
    file.loading = false;
    fileItem.loading = false;
    if (!isPresent) {
      buddhimedCallBack(file.guid, file, file, indexRowValue, fullLetters);
    }
  };

  const onError = (error: any, fileDataItem: any): any => {
    fileDataItem.loading = false;
    file.loading = false;
  };

  const onClickDownloadAll = (event: any, filedata: any): any => {
    const payload = {
      docName: file?.fileName,
      hisPatientSearchReferenceID: referenceId,
      fileGuid: [file?.guid],
      guid: file?.guid,
    };
    if (file?.guid) {
      dispatch(hisFileDownload(payload));
    }
  };

  const printAll = (): void => {
    const payload = {
      attachGuids: [file?.guid],
      guid: file?.guid,
    };
    if (file?.guid) {
      setpdfPreview(true);
      dispatch(hisPrintClaimPDF(payload, getPDFViewer));
    }
  };

  const getPDFViewer = (data: any): void => {
    setTestPdf(data);
    const { fileName: name, isSuccess, fileBytes } = data || {};
    const byteSize = (new Blob([fileBytes]).size) / 1000000;
    if (isSuccess && byteSize < 2) {
      // Get MIME type based on file extension
      const mimeType = getMimeTypeFromExtension(name);

      setTestPdf('data:' + mimeType + ';base64,' + fileBytes);
      centeredNotification(`${name} start previewing...`, 'success');
    } else {
      centeredNotification(`${name} too large, couldn't Preview File `, 'error');
    }
  };

  const formatDate = (dateString: any): any => {
    return moment(dateString)?.format('DD MMM YYYY');
  };

  return (
    <div className="upload-list-HIS-flow his-ml-10">
      <Row gutter={GUTTOR_SPACE} className="upload-files-container">
        <Col md={5} className="padding-18 his-files-name">
          <div className="text-elipsis">
            <FileIcon className="fill-gray v-align-middle" /> &nbsp;
            <span className="His-filename">
              <Popover placement="right" content={<p className="popover-download popover-draft-icon his-docs-name">{fileName}</p>} trigger="hover">
                {fileName}
              </Popover>
            </span>
          </div>
        </Col>
        <Col md={4} className="His-filesize padding-18">
          {fileUploadedatHIS ? formatDate(fileUploadedatHIS) : '-'}
        </Col>
        <Col md={4} className="His-filesize padding-18">
          {file?.loading ? <span className="file-size-loader">fetching...</span> : bytesToMB(file?.size)}
        </Col>
        <Col md={1} className="circular-progress uploaded-file-list-progress his-ml-28">
          {<Progress type="circle" percent={customPercent} width={20} strokeColor="#2ABF86" />}
        </Col>
        {
          <Col md={3} className="His-filename his-classification-name">
            {
              getFileType(fileType)
            }
          </Col>
        }
        <div
          className={`${!hisFileUploads?.length ? 'box-padding checkbox-selection' : 'his-files-selected'} ${!hisFileUploads?.length ? letter?.length > 1
            ? indexRow === 0
              ? 'no-border-bottom'
              : indexRow === letter?.length - 1
                ? 'no-border-top'
                : indexRow > 0 && indexRow < letter?.length - 1
                  ? 'transparent'
                  : ''
            : 'checkbox-selection' : 'his-files-selected'
            }`}
        >
          <Row
            onMouseEnter={(): any => {
              setIsMouseEntered(file?.size && file?.size > maxFileLimit);
            }}

            onMouseLeave={(): any => {
              setIsMouseEntered(false);
            }}
            className={`${!hisFileUploads?.length ? letter?.length > 1
              ? indexRow === 0
                ? 'checkbox-top-14'
                : indexRow === letter?.length - 1
                  ? 'checkbox-top-3'
                  : indexRow > 0 && indexRow < letter?.length - 1
                    ? 'checkbox-top-12'
                    : ''
              : '' : ''
              }`}>

            <Popover
              placement="top"
              content={
                <><div className="popover-download-content display-flex-item file-exceed-warning-text">
                  <span className="file-warning-icon"><File_Size /></span>
                  <span
                    className="file-exceed-warning-text"
                    dangerouslySetInnerHTML={{ __html: getFileSizeLimitMessage(maxFileLimit / MB2Bytes) }}
                  />

                </div></>
              }
              trigger="hover"
              visible={(file?.size && file?.size > maxFileLimit && isMouseEntered)}
            >
              <Col className={`file-checkbox his-checkbox ${!hisFileUploads?.length ? letter?.length === 1 ? 'his-checkbox-l-5-single-file' : 'his-checkbox-l-5' : 'his-checkbox-l-25'}`}>
                <FormCheckBox
                  detail={{
                    key: `checkbox_${file?.uid}`,
                    className: 'checkbox-items',
                    options: [
                      {
                        value: file?.uid,
                        key: `checkbox_${file?.uid}`,
                        name: '',
                        required: false,
                        onChange: (event: any, index: any): any =>
                          changeSelection(event, file, indexRow),
                      },
                    ],
                    size: 24,
                    hideLabel: true,
                    isEditableInDetail: true,
                    disabled: (file?.size && file?.size > maxFileLimit),
                  }}
                />
              </Col>
            </Popover>
          </Row>
        </div>
        <Row className={`action-btn his-action-btn-row-files`} gutter={GUTTOR_SPACE}>
          <Col md={2} className="his-download-icon" onClick={(): any => printAll()}>
            <Popover
              placement="bottom"
              content={<p className="popover-download popover-draft-icon">{file?.uid ? 'View' : 'Select to View'}</p>}
              trigger="hover"
            ><ViewIcon />
            </Popover>

          </Col>
          <Col md={2} className="his-print-icon">
            <Popover
              placement="bottom"
              content={<p className="popover-download popover-draft-icon">{file?.uid ? 'Download' : 'Select to Download'}</p>}
              trigger="hover"
            >
              <DownloadIcon onClick={(event: any): any => onClickDownloadAll(event, file)} />
            </Popover>
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default HisUploadListItem;
